import { useState } from "react";
import { Box, Paper, Typography, List, ListItem, IconButton, Slide, Divider } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import { TIMEZONE_OFFSETS } from "../../../utils/timezoneOffsets";

const TimezoneSelector = ({ open, onClose, currentTimezoneOffset, onTimezoneChange }) => {
	const [selectedOffset, setSelectedOffset] = useState(currentTimezoneOffset || "+00:00");

	const handleTimezoneSelect = (offset) => {
		setSelectedOffset(offset);
		onTimezoneChange?.(offset);
		onClose();
	};

	const renderTimezoneOption = (offset, index, totalItems) => {
		const isSelected = selectedOffset === offset;
		const isLastItem = index === totalItems - 1;

		return (
			<Box key={offset}>
				<ListItem
					onClick={() => handleTimezoneSelect(offset)}
					sx={{
						py: 2,
						px: 3,
						cursor: "pointer",
						"&:hover": {
							backgroundColor: "rgba(28, 70, 180, 0.04)",
						},
						backgroundColor: isSelected ? "rgba(28, 70, 180, 0.08)" : "transparent",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<Typography
						variant="body2"
						sx={{
							color: isSelected ? "#1C46B4" : "#24324A",
							fontWeight: isSelected ? 600 : 500,
						}}
					>
						UTC {offset}
					</Typography>

					{isSelected && <CheckIcon sx={{ color: "#1C46B4", fontSize: 20, ml: 1 }} />}
				</ListItem>
				{!isLastItem && <Divider sx={{ borderColor: "#e0e0e0" }} />}
			</Box>
		);
	};

	return (
		<Slide direction="left" in={open} mountOnEnter unmountOnExit>
			<Paper
				sx={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#F7F9FC",
					borderRadius: 3,
					zIndex: 10,
					display: "flex",
					flexDirection: "column",
					minWidth: 280,
					maxHeight: 500,
				}}
			>
				{/* Header */}
				<Box
					sx={{
						px: 2,
						py: 1.5,
						borderBottom: "1px solid #e0e0e0",
						display: "flex",
						alignItems: "center",
						gap: 1,
					}}
				>
					<IconButton onClick={onClose} size="small" sx={{ color: "#1C46B4" }}>
						<ArrowBackIcon fontSize="small" />
					</IconButton>
					<Typography variant="body1" sx={{ fontWeight: 600, color: "#24324A" }}>
						Select Timezone
					</Typography>
				</Box>

				{/* Timezone List */}
				<Box sx={{ flex: 1, overflow: "auto" }}>
					<List sx={{ py: 0 }}>
						{TIMEZONE_OFFSETS.map((offset, index) => renderTimezoneOption(offset, index, TIMEZONE_OFFSETS.length))}
					</List>
				</Box>
			</Paper>
		</Slide>
	);
};

export default TimezoneSelector;
